import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { navigatingAwayApplicationDetailAlertMessage } from "../services/global.constant";

function useNavigationAway() {
  const { pathname } = useLocation();
  const applicationData = useSelector(
    (state) => state.formProps.applicationData || {}
  );
  const browserAlerts = useSelector(
    (state) => state.navConfig.navConfig?.browserAlerts || {}
  );
  const { applicationType, id, status } = applicationData;

  const showAlertCallback = () => {
    if (browserAlerts.navigatingAwayFromApplicationForm) {
      const isApplicationDetailPath = pathname.includes(
        `applications/${applicationType}/${id}`
      );
      const isOpenOrRejectedApplication =
        status === "Open" || status === "Rejected";
      if (isApplicationDetailPath && isOpenOrRejectedApplication) {
        // eslint-disable-next-line no-alert
        return window.confirm(navigatingAwayApplicationDetailAlertMessage);
      }
    }
    return true;
  };

  return showAlertCallback;
}

export default useNavigationAway;
